import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { CSSTransition } from 'react-transition-group';

import './style.scss';

class TooltipNotify extends React.PureComponent {
    componentDidUpdate() {
        this.calcCenterHorizontal();
    }

    getCoords = (elem) => {
        const box = elem.getBoundingClientRect();

        return {
          top: box.top + window.pageYOffset,
          left: box.left + window.pageXOffset,
          right: box.right
        };
    }

    calcCenterHorizontal = () => {
        const { tooltips } = this.props;
        const isMobile = window.matchMedia('(max-width: 991px)').matches;

        const activeTooltips = tooltips.data.length ? tooltips.data.filter((tooltip) => {
            if (isMobile) {
                if (tooltip.showInMobile && tooltip.show) {
                    return true;
                }
            } else if (tooltip.show) return true;

            return false;
        }) : null;

        if (activeTooltips && activeTooltips.length) {
            activeTooltips.forEach((tooltip) => {
                const offsetTooltipTop = 20;
                const rootElem = document.getElementById(window.vpriemScheduleParams.rootElemID);
                const tooltipElem = document.getElementById(tooltip.id);
                const tooltipTargetElem = document.querySelector(`[tooltipid="${tooltip.id}"]`);

                const tooltipWidth = tooltipElem.offsetWidth;
                const tooltipTargetWidth = tooltipTargetElem.offsetWidth;
                const tooltipTargetHeight = tooltipTargetElem.offsetHeight;
                const coordsTargetElem = this.getCoords(tooltipTargetElem);
                const coordsTooltipElem = this.getCoords(tooltipElem);
                const coordsRootElem = this.getCoords(rootElem);
                const leftPos = (coordsTargetElem.left - coordsTooltipElem.left) - (tooltipWidth / 2 - tooltipTargetWidth / 2);
                const topPos = coordsTargetElem.top + tooltipTargetHeight + offsetTooltipTop - coordsRootElem.top;

                if (isMobile) {
                    const newTooltipCoords = this.getCoords(tooltipElem);
                    if (leftPos <= 0) tooltipElem.style.left = '15px';
                    else if (newTooltipCoords.right >= window.innerWidth / 2) {
                        tooltipElem.style.left = 'unset';
                        tooltipElem.style.right = '15px';
                    } else tooltipElem.style.left = `${leftPos}px`;
                } else {
                    tooltipElem.style.left = isMobile && leftPos <= 0 ? '15px' : `${leftPos}px`;
                }
                tooltipElem.style.top = `${topPos}px`;
            });
        }
    }

    render() {
        const { tooltips } = this.props;
        const isMobile = window.matchMedia('(max-width: 991px)').matches;

        return tooltips.data.length ? tooltips.data.map((tooltip) => {
            if (isMobile && !tooltip.showInMobile) return null;

            return (
                <CSSTransition
                    key={`animate-${tooltip.id}`}
                    classNames="tooltipAnimate"
                    in={tooltip.show}
                    unmountOnExit
                    timeout={{
                        appear: 0,
                        enter: 300,
                        exit: 300,
                    }}
                >
                    <div className="tooltip" id={tooltip.id} key={tooltip.id}>
                        {tooltip.text.length ? tooltip.text.map((line) => {
                            switch (line.type) {
                                case 'text':
                                    return <p key={line.data}>{line.data}</p>;
                                case 'title':
                                    return <strong key={line.data}>{line.data}</strong>;
                                default:
                                    return <p key={line.data}>{line.data}</p>;
                            }
                        }) : null}
                    </div>
                </CSSTransition>
            );
        }) : null;
    }
}

TooltipNotify.propTypes = {
    tooltips: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
    tooltips: state.tooltips
});

export default connect(mapStateToProps)(TooltipNotify);
